import React, { useState, useRef } from "react";
import { 
  Button, 
  Snackbar, 
  CircularProgress, 
  Box,
  Alert 
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { uploadZipFileImages } from "../../../Apiservices/Auth/servers/fetchProviderData";

const ZipUploadButton = () => {
  const [uploading, setUploading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const fileInputRef = useRef(null);

  const handleZipUpload = async (event) => {
    const file = event.target.files[0];
    
    if (!file) {
      return;
    }

    // Validate file type
    if (!file.name.toLowerCase().endsWith('.zip')) {
      setSnackbar({
        open: true,
        message: "Please select a ZIP file",
        severity: "error"
      });
      return;
    }

    // Validate file size (e.g., 50MB limit)
    const maxSize = 50 * 1024 * 1024; // 50MB in bytes
    if (file.size > maxSize) {
      setSnackbar({
        open: true,
        message: "ZIP file size must be less than 50MB",
        severity: "error"
      });
      return;
    }

    setUploading(true);

    try {
      const result = await uploadZipFileImages(file);

      if (result.success) {
        // Handle successful upload
        const summary = result.data?.summary;
        let successMessage = "ZIP file uploaded successfully!";
        
        if (summary) {
          successMessage = `Upload completed! Linked: ${summary.linkedCount} services, Not found: ${summary.missingCount} services`;
          
          if (summary.notFound && summary.notFound.length > 0) {
            successMessage += `\nNot found services: ${summary.notFound.join(', ')}`;
          }
        }
        
        setSnackbar({
          open: true,
          message: successMessage,
          severity: "success"
        });
        
        console.log("Upload result:", result.data);
      } else {
        setSnackbar({
          open: true,
          message: result.error || "Upload failed",
          severity: "error"
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "An unexpected error occurred",
        severity: "error"
      });
    } finally {
      setUploading(false);
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <>
      <input
        type="file"
        accept=".zip"
        onChange={handleZipUpload}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />
      
      <Button 
        variant="contained"  
        startIcon={uploading ? <CircularProgress size={20} color="inherit" /> : <CloudUpload />}
        disabled={uploading}
        sx={{
          backgroundColor: 'black',
          color: 'white',
          '&:hover': {
            backgroundColor: '#333',
          },
          '&:disabled': {
            backgroundColor: '#666',
          },
          marginLeft: '10px' // Add some spacing if needed
        }} 
        onClick={handleButtonClick}
      >
        {uploading ? "Uploading..." : "Upload Images ZIP"}
      </Button>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ZipUploadButton;